import { AiOutlineExclamationCircle } from 'react-icons/ai';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as ArrowForw } from 'assets/images/arrow-forw.svg';
import { ReactComponent as ArrowTransfer } from 'assets/images/arrow-transfer.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.HEX.Lotion};
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 966px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
  }
`;

export const Body = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.HEX.Lotion};
    height: calc(100vh - 80px);
  }
`;

export const FilterTagsContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  min-height: 50px;
  flex-wrap: wrap;

  @media ${({ theme }) => theme.device.mobile} {
    position: sticky;
    top: 80px;
    background: ${ColorPalette.HEX.Lotion};
    z-index: 1;
    overflow-x: auto;
    flex-wrap: nowrap;
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 966px;
    margin: 0 auto 8px;
  }

  &:empty {
    display: none;
  }

  &::after {
    content: '';
    min-width: 1px;
    min-height: 1px;
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 110px;

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 0;
  }
`;

export const NotFound: any = styled.h5`
  text-align: center;
  margin: auto 30px;
  padding-bottom: 50px;
  color: ${({ theme }) => theme.flightsList.notFound};
`;

NotFound.Icon = styled(AiOutlineExclamationCircle)`
  margin: 0 auto 15px auto;
  font-size: 25px;
  width: 100%;
`;

export const OneWayIcon = styled(ArrowForw)`
  width: 16px;
  height: 16px;
  margin: 0 5px 0 2px;
`;
export const RoundTripIcon = styled(ArrowTransfer)`
  width: 16px;
  height: 16px;
  margin: 0 5px 0 3px;
`;

export const Wrapper = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    width: calc(100% - 270px);
    padding: 0 0 0 16px;
  }
`;

export const LeftContainer = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    width: 270px;
  }
`;
